// extracted by mini-css-extract-plugin
export var icon = "_7r-1";
export var subtext = "_7r-0";